export function shouldShowCustomAppsSidebar(input: {
  hasEntitlement: boolean;
  workspaceEnabled: boolean;
  canManageApps: boolean;
  hasLaunchableApps: boolean;
}): boolean {
  return (
    input.hasEntitlement &&
    input.workspaceEnabled &&
    (input.canManageApps || input.hasLaunchableApps)
  );
}
